import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getGlobalCookie } from '../utils';
export default function PrivateRoute ({component: Component, ...rest}) {
  return (
    <Route
      {...rest}
      render={ (props) => getGlobalCookie('lessorAccess') ? <Component {...props} /> : <Redirect to='/login' />
      }
    />
  )
}
